import React from 'react'
import PropTypes from 'prop-types'
import SanityImage from 'gatsby-plugin-sanity-image-alt'
import { useSanityImageShape } from '../helpers/useSanityImageShape'
import {
  buildSanityImageSrcSet,
  buildSanityImageUrl,
} from '../helpers/image'

const SanityResponsiveImage = ({
  image,
  width,
  height,
  widths,
  quality,
  sizes,
  alt,
  ...props
}) => {
  const imageShaped = useSanityImageShape(image)
  const src = buildSanityImageUrl(image, { width, height, quality })
  const srcSet = buildSanityImageSrcSet(image, {
    width,
    height,
    widths,
    quality,
  })

  if (!imageShaped) return null

  return (
    <SanityImage
      {...imageShaped}
      {...props}
      alt={alt}
      width={width}
      height={height}
      sizes={sizes}
      src={src}
      srcSet={srcSet}
    />
  )
}

SanityResponsiveImage.propTypes = {
  image: PropTypes.object,
  width: PropTypes.number.isRequired,
  height: PropTypes.number,
  widths: PropTypes.arrayOf(PropTypes.number),
  quality: PropTypes.number,
  sizes: PropTypes.string,
  alt: PropTypes.string.isRequired,
}

SanityResponsiveImage.defaultProps = {
  image: null,
  height: null,
  widths: [320, 500, 768, 900, 1200],
  quality: 75,
  sizes: '100vw',
}

export default SanityResponsiveImage
